export default function PageHero({ eyebrow, title, subtitle, children, dark = false }) {
  const bg = dark ? "bg-ink text-background" : "bg-subtle";
  const eyebrowClass = dark ? "text-gold" : "";
  return (
    <section className={`${bg} border-b border-border py-20 sm:py-28`}>
      <div className="container-editorial max-w-4xl">
        {eyebrow && <span className={`eyebrow ${eyebrowClass}`}>{eyebrow}</span>}
        <h1 className={`heading-1 mt-4 ${dark ? "text-background" : ""}`}>{title}</h1>
        {subtitle && (
          <p className={`lead mt-6 max-w-2xl ${dark ? "text-background/80" : ""}`}>{subtitle}</p>
        )}
        {children && <div className="mt-8">{children}</div>}
      </div>
    </section>
  );
}
